// extracted by mini-css-extract-plugin
export default {"page":"Feed_page__7nSm0","countries-container":"Feed_countries-container__M-F0Y"};